import JavaScript from "../assets/svg/JavaScript";
import Python from "../assets/svg/Python";
import PHP from "../assets/svg/PHP";
import SQL from "../assets/svg/SQL";
import Cplus from "../assets/svg/Cplus";
import ReactIcon from "../assets/svg/React";
import NodeJS from "../assets/svg/NodeJS";
import Android from "../assets/svg/Android";
import Laravel from "../assets/svg/Laravel";
import Nextjs from "../assets/svg/Nextjs";
import Express from "../assets/svg/Express";
import Mysql from "../assets/svg/Mysql";
import Mongodb from "../assets/svg/Mongodb";
import Firebase from "../assets/svg/Firebase";
import Prisma from "../assets/svg/Prisma";

export const languages = [
  // {
  //   icon: <C height={90} />,
  //   name: "C",
  // },
  {
    icon: <Cplus height={90} />,
    name: "C++",
  },
  // {
  //   icon: <Csharp height={90} />,
  //   name: "C#",
  // },
  {
    icon: <JavaScript height={90} />,
    name: "JavaScript",
  },
  // {
  //   icon: <Kotlin height={90} />,
  //   name: "Kotlin",
  // },
  {
    icon: <Python height={90} />,
    name: "Python",
  },
  {
    icon: <PHP height={90} />,
    name: "PHP",
  },
  {
    icon: <SQL height={90} />,
    name: "SQL",
  },
];

export const shortTech = [
  {
    icon: <Express height={90} />,
    name: "Express JS",
  },
  {
    icon: <ReactIcon height={90} />,
    name: "React",
  },
  {
    icon: <Python height={90} />,
    name: "Python",
  },
  {
    icon: <Laravel height={90} />,
    name: "Laravel",
  },
];

export const frameworks = [
  {
    icon: <Express height={100} />,
    name: "Express JS",
  },
  {
    icon: <ReactIcon height={100} />,
    name: "React",
  },
  {
    icon: <Nextjs height={100} />,
    name: "Next JS",
  },
  {
    icon: <NodeJS height={100} />,
    name: "Node JS",
  },
  {
    icon: <Android height={100} />,
    name: "Android",
  },
  {
    icon: <Laravel height={100} />,
    name: "Laravel",
  },
];

export const databases = [
  {
    icon: <Mysql height={100} />,
    name: "MySQL",
  },
  {
    icon: <Mongodb height={100} />,
    name: "MongoDB",
  },
  {
    icon: <Firebase height={100} />,
    name: "Firebase FireStore",
  },
  {
    icon: <Prisma height={100} />,
    name: "Prisma ORM",
  },
  // {
  //   icon: <PostgreSQL height={100} />,
  //   name: "PostgreSQL",
  // },
];
